import { FC, useMemo } from 'react'

import { ActivityType } from '@forto-dev/feed-v2-models'
import { Chip, Cluster } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { ACTIVITY_FILTERS, FeedActivityFilter } from '../domain/feed'
import { useActivityFeedFilter } from '../hooks'

type ActivityFeedFiltersProps = {
  counts: Partial<Record<ActivityType, number>> | undefined
}

export const ActivityFeedFilters: FC<ActivityFeedFiltersProps> = ({ counts }) => {
  const { translate } = useLocalisation()
  const { activityType, setActivityType } = useActivityFeedFilter()

  const total = useMemo(() => Object.values(counts ?? {}).reduce((acc, count) => acc + count, 0), [counts])

  return (
    <Cluster gap={8} wrap>
      <Chip variant={!activityType ? 'primary' : 'muted'} onClick={() => setActivityType(undefined)}>
        {translate('feed.filters.all')} ({total})
      </Chip>
      {Object.entries(ACTIVITY_FILTERS).map(([type, allowedTypes]) => {
        const typedType = type as FeedActivityFilter
        const count = allowedTypes.reduce((acc, item) => acc + (counts?.[item] ?? 0), 0)

        return (
          <Chip
            key={typedType}
            variant={typedType === activityType ? 'primary' : 'muted'}
            onClick={() => {
              if (typedType === activityType) {
                setActivityType(undefined)
              } else {
                setActivityType(typedType)
              }
            }}
          >
            {translate(`feed.filters.${typedType}`)} ({count})
          </Chip>
        )
      })}
    </Cluster>
  )
}
